import { SCHEMA_UPDATE, SET_CARD_LOADING_STATE } from './types';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { getToastMsg } from '../../components/ErrorMessage';

const patchCardsToDay = ({
  dayNo,
  dataFORAPI,
  trekId,
  cardId,
  editType,
  themeForPatch,
}) => {
  return async dispatch => {
    try {
      dispatch(setLoadingState({ id: cardId, state: true }));
      const response = await api.patch(
        endpoints.treks.addToTrekDay(trekId, dayNo),
        dataFORAPI
      );

      const responseData = {
        ...response.data,
        id: Number(dayNo),
      };
      dispatch(updateDaySchema(responseData));
      dispatch(setLoadingState({ id: cardId, state: false }));
      getToastMsg({
        type: 'patchToDay',
        status: 'success',
        data: { editType, theme: themeForPatch },
      });
      return response;
    } catch (err) {
      dispatch(setLoadingState({ id: cardId, state: false }));
      getToastMsg({
        type: 'patchToDay',
        status: 'error',
        data: { editType, theme: themeForPatch },
      });
      return err;
    }
  };
};

const updateDaySchema = data => {
  return {
    type: SCHEMA_UPDATE,
    payload: {
      schema: 'days',
      data: data,
    },
  };
};

const resolveCardData = ({ oldCardData, cardData, editType, themeForPatch, patchKey }) => {
  if (editType === 'add') {
    var newCardData = {};
    if (themeForPatch === 'lodges') {
      const removeExistingLodge = oldCardData.filter(
        card => card.poster_type !== 'lodgings'
      );
      newCardData = {
        ...cardData,
        poster_type: patchKey,
      };
      return [...removeExistingLodge, newCardData];
    } else {
      newCardData = {
        ...cardData,
        poster_type: themeForPatch,
      };
      return [...oldCardData, newCardData];
    }
  } else if (editType === 'remove') {
    return oldCardData.filter(card => card.id !== cardData.id);
  }
};

export const editDayCard = ({ theme, cardData, editType }) => (dispatch, getState) => {
  const patchInfo = getState().servicesModal.patchInfo;
  const themeFromPlacesModal = getState().placesModal.themeType;
  const themeForPatch = theme ? theme : themeFromPlacesModal;

  const { dayNo, index, segmentId, trekId } = patchInfo;

  let dayData = getState().schema.days.byId[dayNo];
  const oldCardData = dayData.routes[index].posters;

  var patchKey = '';
  var arrayOfId = [];
  var arrayWithData = [];

  if (themeForPatch === 'lodges') {
    patchKey = 'lodgings';
  } else {
    patchKey = themeForPatch;
  }

  const newCardData = resolveCardData({
    oldCardData,
    cardData,
    editType,
    themeForPatch,
    patchKey,
  });

  arrayWithData = newCardData.filter(card => card.poster_type === patchKey);

  arrayWithData.forEach(card => arrayOfId.push(card && card.id));

  const arrayOfIdWithoutNull = arrayOfId.filter(card => card);

  const dataFORAPI = {
    routes: [
      {
        segment_id: segmentId,
        [patchKey]: arrayOfIdWithoutNull,
      },
    ],
  };

  return dispatch(
    patchCardsToDay({
      dayNo,
      dataFORAPI,
      cardId: cardData.id,
      trekId,
      editType,
      themeForPatch,
    })
  );
};

const setLoadingState = ({ id, state }) => {
  return {
    type: SET_CARD_LOADING_STATE,
    data: {
      id,
      state,
    },
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/patchToDay.js